import React from 'react';
import {Link} from "react-router-dom";
import {Image} from "antd";
import Locale from "../util/Locale";

export const miniSvg = <svg width="7" className={'inline-block absolute left-0 -top-2 mr-1.5 -ml-3'} height="50" viewBox="91.81 59 22.43 115.48"
                            preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg">
    <path d="m114.24,69.44l-22.43-12v91.87l22.43,11.61v-91.47Z" stroke="black"/>
</svg>;

function Home() {

    return (
        <div className="dark:bg-gray-800 relative flex-grow">
            <section>
                <div className="px-4 mx-auto max-w-screen-xl py-2 lg:py-16  lg:px-6">
                    <div className="font-light text-gray-700 dark:text-gray-100  relative">
                        <div className={'flex justify-between flex-wrap w-full'}>
                            <h3
                                className="pb-12 relative text-[24px] lg:text-[32px] sm:w-full lg:w-[68%] flex items-center font-bold logo-blue-color py-3 mb-3">
                                <svg viewBox="60.73 -5 22.43 177.64" width={105} preserveAspectRatio="xMidYMid meet"
                                     className={'mr-8 w-0 contents lg:block lg:w-[105px]'} fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="m83.16,12l-22.43-12v154.03l22.43,11.61V12Z" stroke="black"/>
                                </svg>

                                <Locale code={'home.title'}/>
                                {/*<div className={'absolute h-full w-[97%] opacity-10'} style={{background: 'url("/images/mark.png") repeat', backgroundRepeat: "space", backgroundSize: 'contain'}}></div>*/}
                            </h3>
                            <div className={'relative sm:w-full lg:w-[32%] w-full h-72 lg:h-auto overflow-x-clip'}>
                                <div className={'absolute left-1/2 top-[260px] w-full'}>
                                    <div className={'absolute w-[16.7rem] bottom-0 z-10 -translate-x-1/2'}>
                                        <Image className={'image-stroke'} preview={false}
                                               src="/images/profile/hajduk-transparent.png"/>
                                    </div>
                                    <div className={'absolute w-64 bottom-0 -left-24 -translate-x-1/2'}>
                                        <Image className={'image-stroke'} preview={false}
                                               src="/images/profile/jevcik-transparent.png"/>
                                    </div>
                                    <div className={'absolute w-[17.3rem] left-24 bottom-0 -translate-x-1/2'}>
                                        <Image className={'image-stroke'} preview={false}
                                               src="/images/profile/marton-transparent.png"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={'max-w-full left-[50px] h-0 xl:h-1 logo-blue-bg top-[254px] z-20 w-[1154px] absolute '}></div>
                    </div>
                    <div className="space-y-8 md:grid md:grid-cols-3 lg:grid-cols-5 md:gap-6 md:space-y-0">
                        <div className="grid h-full grid-rows-subgrid gap-1" style={{gridRow: "span 3"}}>
                            <Locale code={'home.management'}/>
                            <div className="mt-2 basis-3/5">
                                <div className="flex justify-end"><Link to="/service#management">
                                    <button type="button"
                                            className="hover:text-black border border-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 focus:ring-4 focus:outline-none focus:ring-gray-200 font-medium rounded-lg text-sm px-5 py-1 text-center me-2 mb-2 dark:text-gray-100 dark:hover:text-white dark:focus:ring-gray-600 dark:border-gray-100">
                                        <Locale code={'home.show-more'}/></button>
                                </Link></div>
                                <div className="flex justify-center">
                                    <Image preview={false} alt="working" className="w-full rounded-lg mt-4"
                                           src="/images/working.jpg"/>
                                </div>
                            </div>
                        </div>
                        <div className="grid h-full grid-rows-subgrid gap-1" style={{gridRow: "span 3"}}>
                            <Locale code={'home.controlling'}/>
                            <div className="mt-2 basis-3/5">
                                <div className="flex justify-end"><Link to="/service#controlling">
                                    <button type="button"
                                            className="hover:text-black border border-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 focus:ring-4 focus:outline-none focus:ring-gray-200 font-medium rounded-lg text-sm px-5 py-1 text-center me-2 mb-2 dark:text-gray-100 dark:hover:text-white dark:focus:ring-gray-600 dark:border-gray-100">
                                        <Locale code={'home.show-more'}/></button>
                                </Link></div>
                                <div className="flex justify-center">
                                    <Image preview={false} alt="working" className="w-full rounded-lg mt-4"
                                           src="/images/controlling.jpg"/>
                                </div>
                            </div>
                        </div>
                        <div className="grid h-full grid-rows-subgrid gap-1" style={{gridRow: "span 3"}}>
                            <Locale code={'home.reporting'}/>
                            <div className="mt-2 basis-3/5">
                                <div className="flex justify-end"><Link to="/service#reporting">
                                    <button type="button"
                                            className="hover:text-black border border-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 focus:ring-4 focus:outline-none focus:ring-gray-200 font-medium rounded-lg text-sm px-5 py-1 text-center me-2 mb-2 dark:text-gray-100 dark:hover:text-white dark:focus:ring-gray-600 dark:border-gray-100">
                                        <Locale code={'home.show-more'}/></button>
                                </Link></div>
                                <div className="flex justify-center">
                                    <Image preview={false} alt="working" className="w-full rounded-lg mt-4"
                                           src="/images/profit.jpg"/>
                                </div>
                            </div>
                        </div>
                        <div className="grid h-full grid-rows-subgrid gap-1" style={{gridRow: "span 3"}}>
                            <Locale code={'home.development'}/>
                            <div className="mt-2 basis-3/5">
                                <div className="flex justify-end"><Link to="/service#development">
                                    <button type="button"
                                            className="hover:text-black border border-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 focus:ring-4 focus:outline-none focus:ring-gray-200 font-medium rounded-lg text-sm px-5 py-1 text-center me-2 mb-2 dark:text-gray-100 dark:hover:text-white dark:focus:ring-gray-600 dark:border-gray-100">
                                        <Locale code={'home.show-more'}/></button>
                                </Link></div>
                                <div className="flex justify-center">
                                    <Image preview={false} alt="working" className="w-full rounded-lg mt-4"
                                           src="/images/development.jpg"/>
                                </div>
                            </div>
                        </div>
                        <div className="grid h-full grid-rows-subgrid gap-1" style={{gridRow: "span 3"}}>
                            <Locale code={'home.education'}/>
                            <div className="mt-2 basis-3/5">
                                <div className="flex justify-end"><Link to="/service#education">
                                    <button type="button"
                                            className="hover:text-black border border-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 focus:ring-4 focus:outline-none focus:ring-gray-200 font-medium rounded-lg text-sm px-5 py-1 text-center me-2 mb-2 dark:text-gray-100 dark:hover:text-white dark:focus:ring-gray-600 dark:border-gray-100">
                                        <Locale code={'home.show-more'}/></button>
                                </Link></div>
                                <div className="flex justify-center">
                                    <Image preview={false} alt="working" className="w-full rounded-lg mt-4"
                                           src="/images/education.jpg"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                );
            </section>
        </div>
    );
}

export default Home;
